import humps from 'humps';
import { MESSAGES_COUNT_PER_PAGE } from 'Constants/webchat';
import { WEBCHAT } from 'Constants/normalize-module';
import { API_CONSULT } from 'Constants/client-modules';
import { messageSchema } from 'Schemas/schemas';

import * as ACTION_TYPES from './types';

export function getMessagesBackwardByTime(params = {}, isReplace = false) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_REQUESTED,
      ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_SUCCEED,
      ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_FAILED,
    ],
    promise: client =>
      client.get('/messages/', {
        params: { ...params, direction: 0, count: MESSAGES_COUNT_PER_PAGE },
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [messageSchema],
      },
      params,
      module: WEBCHAT,
      isReplace,
    },
  };
}

export function getMessagesForwardByTime(params = {}) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_REQUESTED,
      ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_SUCCEED,
      ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_FAILED,
    ],
    promise: client =>
      client.get('/messages/', {
        params: { ...params, direction: 1, count: MESSAGES_COUNT_PER_PAGE },
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [messageSchema],
      },
      module: WEBCHAT,
      params,
    },
  };
}

export function messageMarkAsRead(body) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_READ_REQUESTED,
      ACTION_TYPES.MESSAGES_READ_SUCCEED,
      ACTION_TYPES.MESSAGES_READ_FAILED,
    ],
    promise: client => client.post('/messages/read', body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function messagesClear() {
  return {
    type: ACTION_TYPES.MESSAGES_CLEAR,
    payload: {},
  };
}

export function messagesAddNew(message) {
  return {
    type: ACTION_TYPES.MESSAGE_ADD_NEW,
    payload: {
      message: humps.camelizeKeys(message),
    },
    meta: {
      schema: {
        message: messageSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function messagesReceive(message, groupIdActive = '') {
  return {
    type: ACTION_TYPES.MESSAGE_RECEIVED,
    payload: {
      message,
      groupIdActive,
    },
    meta: {
      schema: {
        message: messageSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function messageGoToTimeSusscess(messageId) {
  return {
    type: ACTION_TYPES.MESSAGES_RETRIEVE_GOTO_TIME_SUCCEED,
    payload: { messageId },
  };
}

export function getMessageGoToTime(params) {
  return dispatch => {
    Promise.all([
      dispatch(getMessagesBackwardByTime(params)),
      dispatch(getMessagesForwardByTime(params)),
    ]).then(results => {
      const messagesBackward = results[0].data;
      const messagesForward = results[1].data;
      let messageId = '';
      if (messagesBackward.length > 0) {
        messageId = messagesBackward[messagesBackward.length - 1].id;
      } else if (messagesForward.length > 0) {
        messageId = messagesForward[0].id;
      }
      dispatch(messageGoToTimeSusscess(messageId));
    });
  };
}

export function getPrivateMessagesBackwardByTime(params = {}) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_REQUESTED,
      ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_SUCCEED,
      ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_FAILED,
    ],
    promise: client =>
      client.get('/messages/conversation', {
        params: { ...params, direction: 0, count: MESSAGES_COUNT_PER_PAGE },
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [messageSchema],
      },
      module: WEBCHAT,
    },
  };
}

export function getMessagesRequestPool(consultId) {
  return {
    types: [
      ACTION_TYPES.MESSAGES_REQUEST_POOL_REQUESTED,
      ACTION_TYPES.MESSAGES_REQUEST_POOL_SUCCEED,
      ACTION_TYPES.MESSAGES_REQUEST_POOL_FAILED,
    ],
    promise: client => client.get(`consults/${consultId}/request-messages`),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [messageSchema],
      },
      module: WEBCHAT,
      params: {
        consultId,
      },
    },
  };
}

export function addMessageToBubble(id, messages) {
  return {
    type: ACTION_TYPES.ADD_BUBBLE_MESSAGE_REQUESTED,
    payload: { id, messages },
  };
}

export function clearConversationMessageById(conversationId) {
  return {
    type: ACTION_TYPES.CONVERSATION_CLEAR_MESSAGES,
    payload: { conversationId },
  };
}

export function setJumpMessage(message) {
  return {
    type: ACTION_TYPES.MESSAGE_SET_JUMP_MESSAGE,
    payload: { message },
  };
}

export function messageRemove(message) {
  return {
    type: ACTION_TYPES.MESSAGE_REMOVE_BY_ID,
    payload: { message },
  };
}
